"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _button = _interopRequireDefault(require("@clayui/button"));

var _form = require("@clayui/form");

var _icon = _interopRequireDefault(require("@clayui/icon"));

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ClayDropDownSearch = function ClayDropDownSearch(_ref) {
  var className = _ref.className,
      _ref$formProps = _ref.formProps,
      formProps = _ref$formProps === void 0 ? {} : _ref$formProps,
      spritemap = _ref.spritemap,
      otherProps = _objectWithoutProperties(_ref, ["className", "formProps", "spritemap"]);

  var formClassName = formProps.className,
      otherFormProps = _objectWithoutProperties(formProps, ["className"]);

  return /*#__PURE__*/_react.default.createElement("form", _extends({
    className: (0, _classnames.default)(className, formClassName)
  }, otherFormProps), /*#__PURE__*/_react.default.createElement("div", {
    className: "dropdown-section"
  }, /*#__PURE__*/_react.default.createElement(_form.ClayInput.Group, {
    small: true
  }, /*#__PURE__*/_react.default.createElement(_form.ClayInput.GroupItem, null, /*#__PURE__*/_react.default.createElement(_form.ClayInput, _extends({}, otherProps, {
    insetAfter: true,
    type: "text"
  })), /*#__PURE__*/_react.default.createElement(_form.ClayInput.GroupInsetItem, {
    after: true,
    tag: "span"
  }, /*#__PURE__*/_react.default.createElement(_button.default, {
    displayType: "unstyled",
    type: "button"
  }, /*#__PURE__*/_react.default.createElement(_icon.default, {
    spritemap: spritemap,
    symbol: "search"
  })))))));
};

var _default = ClayDropDownSearch;
exports.default = _default;